<template>
    <div style="overflow-x: auto; border-radius: 10px; max-width: 50%;">
        <table>
         <!--    <caption class="table-header">{{ this.$t('tabs.electricidad_swap') }}</caption> -->
            <thead>
              <tr>
                <th class="encabezado" ></th>
                <th class="encabezado" >Swap 1</th>
                <th class="encabezado" >Swap 2</th>
                <th class="encabezado" >Swap 3</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(label, index) in label_resumido" :key="index" class="tabla-hover">
                <td class="primera_columna">{{ this.$t('tabs.swap.'+label)}}</td>
                <td >
                    <input type="number" v-model.number="parametros[0][label]" 
                    @input="emitChanges"
                    style="padding-left: 45% !important;"
                    step="0.1"/>
                </td>
                <td>
                    <input type="number" v-model.number="parametros[1][label]" 
                    @input="emitChanges"
                    style="padding-left: 45% !important;"
                    step="0.1"/>
                </td>
                <td>
                    <input type="number" v-model.number="parametros[2][label]" 
                    @input="emitChanges"
                    style="padding-left: 45% !important;"
                    step="0.1"
                    />
                </td>
            </tr>
              
            </tbody>
          </table>
    </div>
    </template>
    
    <script>
    export default {
        props:{
            elec_swap:{
                type:Array,
                required:true,
            },
        },
        data(){
                return {
                    parametros:[...this.elec_swap],
                    
                    label_resumido:['cantidad','precio'],

    
                }
        },
        created(){
        },
        methods:{
            emitChanges(){
            this.$emit("update:elec_swap", this.parametros);
          },
        },
        watch:{
    
        },
    }
    </script>
    
    <style scoped>
    table {
        width: 100%;
        border-collapse: collapse;
        text-align: center;
      }
      .table-header {
        font-size: 1.5em;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
        color: white;
        background-color: #006699;
      }
      
      
      .primera_columna{
        background-color: white;
      }
      .valor_fijo{
        background-color: white;
      }
/*       td {
        font-weight: bold;
        color: #024e74;
        border: 2px solid #D9D9D9;
        padding: 10px;
        background-color: #F2F2F2;
      } */
      input[type="number"] {
        width: 100%;
        text-align: center;
        border: none;
        border-radius: 4px;
        color: #024e74;
      }
      
      select {
        width: 100%;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        text-align: center;
        color: #024e74;
      }
      
      input[disabled] {
        background-color: white;
        color: #024e74;
        cursor: not-allowed;
      }
    
    </style>